<template>
    <div ref="bottomsheet" class="bottomsheet" :id="id">
        <div class="bottomsheet-background" @click="closeBottomsheet()">
            &nbsp;
        </div>
        <div class="bottomsheet-content">
            <div class="bottomsheet-header">
                <h3>{{ title }}</h3>
                <button class="close" @click="closeBottomsheet()"></button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomSheet",
    props: {
        id: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Bottom Sheet",
        },
    },
    methods: {
        openBottomsheet() {
            const bottomsheet = this.$refs.bottomsheet;
            bottomsheet.classList.add("open");
            setTimeout(() => {
                bottomsheet.style.opacity = 1;
                bottomsheet.querySelector(
                    ".bottomsheet-content"
                ).style.transform = "translateY(0)";
            }, 100);
        },
        closeBottomsheet() {
            const bottomsheet = this.$refs.bottomsheet;
            bottomsheet.style.opacity = 0;
            bottomsheet.querySelector(".bottomsheet-content").style.transform =
                "translateY(100%)";
            setTimeout(() => {
                bottomsheet.classList.remove("open");
            }, 300);
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;
.bottomsheet {
    display: none;
    z-index: 100;
    opacity: 0;
    transition: opacity 0.3s;

    &.open {
        display: flex;
    }

    .bottomsheet-background {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 101;
    }

    .bottomsheet-content {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        padding: 24px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        background-color: $color-white;
        transform: translateY(100%);
        transition: transform 0.3s;
        z-index: 102;

        .bottomsheet-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            column-gap: 8px;

            .close {
                width: 24px;
                height: 24px;
                border: none;
                background-color: transparent;
                background-image: url("~@/assets/customizer_icon_close.svg");
                background-size: 11px;
                background-repeat: no-repeat;
                background-position: center center;
                cursor: pointer;
            }
        }
    }
}
</style>
